
import 'cirrus-ui'
import { Header } from './components/Header';
import { SplashScreen } from './components/SplashScreen';
import { Footer } from './components/Footer';


export function App() {
   return (
      <div className="App">
         <Header />
         <SplashScreen></SplashScreen>
      </div>
   );
}